// removed by extract-text-webpack-plugin
module.exports = {"component":"Header__component___1ZDSM","wrapper":"Header__wrapper___11qnu","logo":"Header__logo___3_Bnl","searchBar":"Header__searchBar____JEoY","searchButton":"Header__searchButton___24nxQ","searchIcon":"Header__searchIcon___3nm_N"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/Header.css
// module id = 409
// module chunks = 0